import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import BaseGrid from '../Common/BaseGrid';
import * as url from '../../helpers/url_helper';

function UserSelector(props) {
  const { onSelect } = props;

  const selectUser = (user) => {
    onSelect(user);
  };

  return (
    <BaseGrid
      url={url.GET_LOCATION_LOG_USERS}
      hasSearch
      config={{
        columns: {
          real_name: { label: 'User', sort: true },
          actions: {
            label: 'Actions',
            actions: [
              {
                key: 'select_user',
                icon: 'mdi mdi-check-bold',
                class: 'btn btn-sm btn-soft-info text-dark',
                alt: 'Select',
                click: selectUser,
              },
            ],
          },
        },
        pagination: {
          sort: 'user',
          direction: 'asc',
          perPage: 10,
        },
      }}
    />
  );
}

UserSelector.defaultProps = {
  onSelect: () => {},
};

UserSelector.propTypes = {
  onSelect: PropTypes.func,
};

export default connect(() => ({}), {})(withTranslation()(UserSelector));
